import React, { useEffect, useLayoutEffect, useState, useContext, useRef } from 'react';
import { AppContext } from '../../context/AppContext.jsx';
import axios from 'axios';
import { useLanguage } from "../../i18n/LanguageContext.jsx";
import i18n from "../../i18n/i18n";
import { Link } from 'react-router-dom';
import ProgettiList from '../../components/ProgettiList.jsx';

const ProgettiHpTemplate = ({ itemId, pageTitle }) => {
    const { language } = useLanguage();
    const [page, setPage] = useState(null);
    const [articles, setArticles] = useState(null);
    const [componentLoaded, setComponentLoaded] = useState(false);
    const { siteMap } = useContext(AppContext);

    const pageUrl = `/${language}${process.env.REACT_APP_API_PAGE_URL}`;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${pageUrl}/${itemId}`);
                setPage(res.data);
                console.log("Progetti Home Page", res.data);
            } catch (error) {
                console.error('Errore durante il fetchla pagina:', error);
            }
        };
        fetchData();
    }, [pageUrl, itemId]);

    useEffect(() => {
        if (page && siteMap) {
            setComponentLoaded(true);
        } else {
            setComponentLoaded(false);
        }
    }, [page, siteMap]);

    useEffect(() => {
        if (page && page.articles) {
            setArticles(page.articles);
        }
    }, [page]);

    return (
        <>
            {page && siteMap && (
                <>
                    {articles && articles.items && articles.items.length > 0 && (
                        <ProgettiList articles={articles} pageId={page.id } />
                    )}
                </>
            )}
        </>
    );
};

export default ProgettiHpTemplate; 